const typography = {
    body1: {
        fontFamily: 'Mulish, sans-serif',
    },
    body2: {
        fontFamily: 'Mulish, sans-serif',
    },
    h1: {
        color: '#000',
        fontFamily: 'Montserrat, sans-serif',
        fontSize: '3.2rem',
        textAlign: 'left',
        letterSpacing: 1,
        fontWeight: 600,
    },
    h2: {
        color: '#000',
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 500,
        fontSize: '1.5rem',
        margin: '10px 0',
        textAlign: 'left',
    },
    h3: {
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 500,
    },
    h4: {
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 500,
    },
    h5: {
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 500,
    },
    h6: {
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 500,
    },
    overline: {
        fontWeight: 500,
    },
    p: {
        marginBottom: '10px !important',
    },
};

export default typography;
